<!--
================================================
Un composant permettant de filter la report view par taskName

Url d'accès : http://localhost:8080/fr/cronocloud-inc/reports/summary



* FONCTIONNEMENT :

    Lorsque l'on filtre un pointage par son taskName dans la liste, les timerecords correspondants sont inclus dans les résultats de la ReportsView.
    //IMPORTANT : Ce sont les paramètres d'url qui vont faire que la view report va charger/filtrer les données

LIMITATION DU COMPOSANT :


================================================
-->

<!------------------------------------------------
+++++++++++++++++++++ HTML +++++++++++++++++++++++
-------------------------------------------------->

<template>
  <div id="TaskNameFilterComp" v-bind:class="{'darkMode':themeToDisplay=='dark'}" v-click-outside="onClickOutside">


    <div class="selector">

      <div class="count" v-show="filterCount >= 1">{{ filterCount }}</div>

      <div class="opener" v-on:click="toggleList()" v-bind:title="$t('filtrerParDescription')">
        <span><font-awesome-icon class="icon iconType is-pulled-left" :icon="['far', 'bookmark']"/></span>
        <span class="text ">{{ $t('description') }}</span>
        <span><font-awesome-icon class="icon is-pulled-right chevron " :icon="['fas', 'chevron-down']"/></span>
      </div>

      <div class=" list" v-show="listVisibility">
        <ul>
          <!--          <div class="loaderZone" v-if="componentIsReady ==false">-->
          <!--            <div class="txt">{{$t('chargementDesProjets')}}...</div>-->
          <!--&lt;!&ndash;            <spinner-loader-comp></spinner-loader-comp>&ndash;&gt;-->
          <!--          </div>-->
          <div v-if="componentIsReady" class="filterContent">


            <div class="field">
              <div class="control has-icons-right">
                <input type="text" ref="taskNameFilter" :placeholder="$t('descriptionDuPointage')"
                       class="taskNameInput input is-fullwidth" v-model="taskName"
                       v-on:keypress.enter="updateCount(), emitFilterState(), toggleList(), updateUrlFilterParam() ">
                <font-awesome-icon class="icon is-right" :icon="['fas', 'search']"/>
              </div>
            </div>

            <li class="noRelatedEntries">
              <label class="checkbox" v-on:change="updateCount(),emitFilterState()">
                <input type="checkbox" id="noRelatedFilterTaskName"
                       v-model="noRelatedFilter">{{ $t('PointagesSansDescription') }}
              </label>
            </li>


          </div>


        </ul>
      </div>


    </div>


  </div>

</template>

<!------------------------------------------------
+++++++++++++++++++ JAVASCRIPT++++++++++++++++++++
-------------------------------------------------->


<script>
import {mapState} from 'vuex'
// import SpinnerLoaderComp from "../SpinnerLoaderComp";
import SentryMixin from "../../mixins/SentryMixin";
import GlobalErrorNotification from "../../mixins/GlobalErrorNotificationMixin";
import InterceptorMixin from "../../mixins/InterceptorMixin";
import _ from "lodash";
import vClickOutside from 'v-click-outside'

export default {
  name: 'TaskNameFilterComp',
  components: {
    // SpinnerLoaderComp
  },

  directives: {
    clickOutside: vClickOutside.directive, // en event mouseleave peut-être une alternative !
  },
  mixins: [GlobalErrorNotification, SentryMixin, InterceptorMixin],
  data: function () {
    return {
      userSlug: JSON.parse(this.$cookie.get('auth')).userSlug,
      listVisibility: false, // bool la visibilité de la liste
      componentIsReady: false, // indique quand le composant est prêt à être affiché NOTE: non utilisé dans ce composant provient du composant initialement dupliqué (projectFilterComp) conservé à des fins de standardisation
      filterCount: 0, //int le nombre d'éléments à filter,
      noRelatedFilter: false, //bool, indique s'il faut inclure les timerecords sans taskName
      taskName: '', //string,  string sur laquelle il faut filter les pointages | @todo voir implémentation  https://gitlab.com/ousmane1/kronocloud/-/issues/527)

    }
  },

  computed: {
    // computed props for store :
    ...mapState({
      user: state => state.user,
      themeToDisplay: state => state.app.themeToDisplay

    }),
    //----------------------------------------------

  },
  watch: {

    // maj du param d'url 'taskNameNoRel' quand noRelatedFilter change
    noRelatedFilter: function () {
      let value
      switch (this.noRelatedFilter) {
        case  true:
          value = '1';
          break;
        case  false:
          value = '0';
          break;
        default:
          break;
      }
      this.$router.push({query: {...this.$route.query,taskNameNoRel: value}});
    },
  },


  methods: {

    /* Masque le filtre lorsque l'on clique en dehors*/
    onClickOutside(event) {
      this.hideList()
    },

    /*
        Stockage de l'état du filtre dans le store
        (Avec les valeurs de this.noRelatedFilter & this.taskName)
        Sert à updater les critères de tri dans ReportsView
     */
    emitFilterState() {
      this.$store.commit('UpdateReportsViewFilterRulesTaskName', {
        noRelated: this.noRelatedFilter,
        description: this.taskName
      });

    },

    /*
      Affiche/masque la partie intérieure du filtre
    */
    toggleList() {
      if (this.listVisibility == true) {
        this.hideList()
      } else {
        this.showList()
        this.$nextTick(() => {
          this.$refs.taskNameFilter.focus()
        }) // focus du champ
      }
    },

    showList() {
      this.listVisibility = true;
    },
    hideList() {
      this.listVisibility = false;
    },

    /**
     * Calcul le nombre total d'éléments activés dans le filtre.
     */
    updateCount() {
      let total = 0;
      if (!_.isEmpty(this.taskName)) {
        total++
      }
      if (this.noRelatedFilter) {
        total = total + 1
      }
      this.filterCount = total

      this.$root.$emit('filter_taskname_count_update', total)
    },


    /*
      Met à jour les paramètres du filtre dans l'url (en fonction de l'état du filtre)
    */
    updateUrlFilterParam() {
      if (_.isEmpty(this.taskName)) {
        this.$router.push({query: {...this.$route.query, taskNameFilter: null}});
      } else {
          this.$router.push({query: {...this.$route.query, taskNameFilter: this.taskName}});
      }

    },


    /**
     * Réinitialise le composant à sa valeur d'origine (désactive tous les filtres)
     */
    resetFilter() {
      this.filterCount = 0;
      this.taskName = '';
      this.noRelatedFilter = false

      // vidage du taskName filter dans le store (permettra de reset le filtrage dans la reportView)
      this.$store.commit('UpdateReportsViewFilterRulesTaskName', {
        noRelated: null,
        description: ''

      });

      //vidage du taskNameFilter dans l'url
      this.$router.push({query: {...this.$route.query, taskNameFilter: null}});

    }



    /*
     Configure le filtre en fonction des paramètres d'url
     */
    , initConfigFromUrl() {

      // 1. configuration de l'affichage du filtre taskname demandé, si taskName est fournit dans l'url on l'utilise pour configurer les filtre
      if (!_.isEmpty(this.$route.query.taskNameFilter)) {
        this.taskName = this.$route.query.taskNameFilter
      }

      // 2. configuration de l'affichage des tr sans description, si taskNameNoRel est fournit dans l'url on l'utilise pour configurer le filtre
      if (this.$route.query.taskNameNoRel != null) {
        (this.$route.query.taskNameNoRel == '1') ? this.noRelatedFilter = true : this.noRelatedFilter = false
      }


      this.updateCount()

    }
  },

  // LIFECYCLE HOOKS (https://v2.vuejs.org/v2/guide/instance.html#Lifecycle-Diagram)
  mounted: function () {


    this.initConfigFromUrl()
    this.componentIsReady = true

    // écoute de l'évent 'reinit_filters' emit depuis FiltersComp
    this.$root.$on('reinit_filters', () => {
      this.resetFilter()
    })


    let self = this;
    setTimeout(function () {
      self.updateCount();
    }, 200) // ici j'ai dû décaler le déclenchement de 200ms pour que cela fonctionne.

  },
}
</script>

<!------------------------------------------------
++++++++++++++++++++++ CSS +++++++++++++++++++++++
-------------------------------------------------->

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
@import "../../assets/css/globalVar.scss";
@import "../../assets/css/bulmaResponsiveDep.scss";

//NOTE : ce composant ayant été créé après les filtres projet et client leurs styles avaient été mutualisé dans FiltersComp. Ce composant étant assez différent car basé non pas sur des checkbox mais un input j'ai défini son style ici (mais il se peut que filtersComp influence quand même l'afficahge

#TaskNameFilterComp {

  //////////////////////////////////////////
  // LIGHT THEME ///////////////////////////

  // les styles appliqués ici sont ceux spécifique à ce filtre (sinon les styles communs sont dans FiltersComp)

  //width: 500px;
  .list {
    @include touch {
      min-width: 100%;
    }

    .filterContent {
      min-width: 15rem !important;
    }

  }

  .field { //@todo en fait refactorer dans filtersComp pour ticket https://gitlab.com/ousmane1/kronocloud/-/issues/518
    width: 100%;
    position: relative;
    padding: .8rem;

    .taskNameInput {
      background-color: $superLightBlue;
      padding: 1.2rem 1rem !important;
      font-size: .95rem;
      color: $brandThird;
    }

    .icon {
      color: $brandBlue;
      font-size: .5rem;
      margin: .65rem .8rem;
    }
  }

  .noRelatedEntries {
    border-bottom: none;
  }


  /////////////////////////////////////////
  // DARK THEME ///////////////////////////
  &.darkMode {
    .taskNameInput {
      &::placeholder {
        color:lighten($darkBg,10%) !important;
      }
    }

    .icon {
      color: $darkLightBlue;
    }
  }
}
</style>
